<template>
  <div>

    <div class="panel panel-default">
      <div class="panel-heading">Товары</div>

      <div class="panel-body">
        <div class="loader" v-show="!loaded" style="
        position: absolute;
        inset: 0px 15px;
        background-color: aliceblue;
        z-index: 10;
        opacity: 0.8;"></div>
        <div class="row">
          <div class="col-md-8" style="line-height: 34px;">
            Категория
            <select name="" id="filter-category-id" style="margin-left: 7px; padding: 5px;" v-model="filterCategory" @change="onFilter">
              <option :value="null">Все</option>
              <option :value="item.id" v-for="item in categories">{{item.name}}</option>
            </select>
          </div>
          <div class="col-md-4">
            <button class="btn btn-default pull-right" type="submit" @click="exportEmails('email.csv')">
              Экспортировать email-ы
            </button>
            <button class="btn btn-default pull-right" type="submit" @click="add()" style="margin-right: 7px;">
              Добавить
            </button>
          </div>
        </div>

        <table class="table">
          <thead>
          <tr>
            <th>#</th>
            <th>Фото</th>
            <th width="300">Название</th>
            <th>Категории</th>
            <th>Начинки</th>
            <th>Сортировка</th>
            <th>Крепкий алк.</th>
            <th>Не в наличии</th>
            <th>Цена</th>
            <th class="text-right">Действие</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in list" v-bind:key="item.id" :class="{'hidden-element': !item.visible}">
            <td>{{item.id}}</td>
            <td><img :src="url+item.image" width="60" alt=""></td>
            <td>
              <strong style="display:block">{{item.name}}</strong>
              {{item.composition}}
            </td>
            <td>{{item.category ? item.category.name : ''}} </td>
            <td>
              <div v-for="sctg in item.subcategories" v-bind:key="sctg.id">{{sctg.name}}</div>
            </td>
            <td>{{item.sort}}</td>
            <td>{{item.hide_price ? 'Да' : 'Нет'}}</td>
            <td>{{item.not_available ? 'Да' : 'Нет'}}</td>
            <td>{{item.price}}</td>
            <td>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="edit(item)">
                <span class="glyphicon glyphicon-edit"></span>
              </button>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="del(item.id, item.name)">
                <span class="glyphicon glyphicon-trash"></span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-model="modalShow" title="Карточка товара" @hide="modalHide()" @before-close="beforeClose">

        <!--error-->
        <div class="alert alert-danger fade in" v-show="modalError">
          <p>{{modalError}}</p>
        </div>

        <!--form-->
        <form name="modal-form" id="modal-form">
          <div class="form-group">
            <label for="image">Изображение</label>
            <div class="image-wrap" :style="{backgroundImage: 'url('+url+modalData.image+')'}">
              <span v-show="!modalData.image">Изображение отсутствует</span>
            </div>
            <input type="file" id="image">
            <p class="help-block">Выберите изображение для загрузки (371x248 jpg,png)</p>
          </div>
          <div class="form-group">
            <label for="image_alt" class="control-label">Изображение (атрибут ALT):</label>
            <input class="form-control" id="image_alt" v-model="modalData.image_alt">
          </div>
          <div class="form-group">
            <label for="image_title" class="control-label">Изображение (атрибут TITLE):</label>
            <input class="form-control" id="image_title" v-model="modalData.image_title">
          </div>
          <div class="form-group">
            <label for="name" class="control-label">Название:</label>
            <input class="form-control" id="name" v-model="modalData.name">
          </div>
          <div class="form-group">
            <label for="slug" class="control-label">URL (только латинские буквы и "-"):</label>
            <input class="form-control" id="slug" v-model="modalData.slug">
          </div>
          <div class="form-group">
            <label for="category" class="control-label">Категория:</label>
            <select id="category" class="form-control" v-model="modalData.product_category_id">
              <option value="">-- Выберите категорию</option>
              <option v-for="ctg in categories" :value="ctg.id" :key="ctg.id">
                {{ctg.name}}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="categories" class="control-label">Начинки:</label>
            <select id="categories" class="form-control" multiple v-model="modalData.subcategories_ids">
              <option v-for="sctg in selectedSubcategories" v-bind:value="sctg.id" :key="sctg.id">
                {{sctg.name}}
              </option>
            </select>
            <p class="help-block">Чтобы выбрать несколько зажмите кнопку CTRL</p>
          </div>
          <div class="form-group">
            <label for="description" class="control-label">Полное описание:</label>
            <textarea class="form-control" rows="3" id="description"
                  v-model="modalData.description"></textarea>
          </div>
          <div class="form-group">
            <label for="composition" class="control-label">Состав:</label>
            <textarea class="form-control" rows="3" id="composition"
                      v-model="modalData.composition"></textarea>
          </div>
          <div class="form-group">
            <label for="sort" class="control-label">Сортировка:</label>
            <input class="form-control" id="sort" v-model="modalData.sort">
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="modalData.hide_price">
              Крепкий алк.
            </label>
          </div>
        </form>

        <div class="checkbox" style="margin-top:35px;">
          <label>
            <input type="checkbox" v-model="modalData.visible">
            Включить показ на сайте
          </label>
        </div>
        <div class="checkbox" style="margin-top:35px;">
          <label>
            <input type="checkbox" v-model="modalData.not_available">Нет в наличии</label>
        </div>

        <div class="form-group">
          <label for="seo_title" class="control-label">SEO Title:</label>
          <input class="form-control" id="seo_title" v-model="modalData.seo_title" rows="15">
        </div>
        <div class="form-group">
          <label for="seo_description" class="control-label">SEO Description:</label>
          <textarea class="form-control" id="seo_description" v-model="modalData.seo_description" rows="10"></textarea>
        </div>
        <div class="form-group">
          <label for="search" class="control-label">Дополнительный текст для поиска (синонимы):</label>
          <textarea class="form-control" id="search" v-model="modalData.search" rows="10"></textarea>
        </div>

        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="modalData.is_ratable">
            Отображать рейтинг
          </label>
        </div>
        <div class="form-group">
          <label for="rate" class="control-label">Оценка:</label>
          <input type="number" class="form-control" id="rate" v-model="modalData.rate">
        </div>
        <div class="form-group">
          <label for="rate_count" class="control-label">Количество проголосовавших:</label>
          <input type="number" class="form-control" id="rate_count" v-model="modalData.rate_count">
        </div>

        <div class="alert alert-danger" role="alert" v-show="!modalData.id">
          <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          После сохранения продуктов можно будет установить цены
        </div>

        <!-- form price -->
        <form class="form-inline" v-show="modalData.id">
            <div class="form-group">
                <label for="price-name">Название</label>
                <input class="form-control" id="price-name" v-model="price_new.price_name" placeholder="2кг" style="width:80px;">
            </div>
            <div class="form-group">
                <label for="price-value">Цена</label>
                <input class="form-control" id="price-value" v-model="price_new.price_value" placeholder="700" style="width:80px;">
            </div>
            <div class="form-group">
              <label for="price-value">Артикул</label>
              <input type="text" class="form-control" id="price-code" v-model="price_new.code" placeholder="AA82888190033" style=";">
            </div>
            <button type="submit" class="btn btn-default" @click="addPrice()">+</button>
        </form>

        <!-- prices -->
        <table class="table" style="margin-top: 15px;" v-show="modalData.id">
          <thead>
            <th>Характеристика</th>
            <th>Цена</th>
            <th>Артикул</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="item in modalData.prices">
              <td>{{item.price_name}}</td>
              <td>{{formatPrice(item.price_value)}}</td>
              <td>{{item.code}}</td>
              <td>
                <button
                    type="button"
                    class="btn btn-default btn-sm pull-right"
                    @click.prevent="delPrice(item.id, item.price_name)"><span
                    class="glyphicon glyphicon-trash"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- form photos -->
        <form class="form-inline" v-show="modalData.id">
          <div class="form-group">
            <label for="photo-file">Фото</label>
            <input type="file" class="form-control" id="photo-file" @change="addPhoto">
          </div>
        </form>

        <!-- photos -->
        <table class="table" style="margin-top: 15px;" v-show="modalData.id">
          <thead>
          <th>#</th>
          <th>Фото</th>
          <th>Пирог в разрезе</th>
          <th></th>
          </thead>
          <tbody>
          <tr v-for="item in photos" :class="{whenHover: item.when_hover}">
            <td>{{item.id}}</td>
            <td><img :src="url+item.url" width="60" alt=""></td>
            <td><input type="radio" name="with_hover" :value="item.id"  @change="setHoverImage(item.id)"></td>
            <td>
              <button class="btn btn-default btn-sm pull-right"
                @click.prevent="delPhoto(item.id)">
                <span class="glyphicon glyphicon-trash"></span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>

        <!-- footer -->
        <div slot="footer">
          <btn type="primary" class="pull-left" @click="store()">Сохранить</btn>
          <btn type="default" class="pull-left" @click="close()">Отмена</btn>
        </div>

    </modal>
  </div>
</template>

<script>
  import {api} from './http'
  var config = require('./config')

  export default {
    mounted () {
    },
    data () {
      return {
        url: config.appUrl,
        modalShow: false,
        modalData: {
          subcategories_ids: [],
          photos: [],
          product_category_id: null
        },
        price_new: {},
        modalError: '',
        categories: [],
        subcategories: [],
        loaded: false,
        list: [],
        photo_new: null,
        photos: [],
        filterCategory: null
      }
    },
    computed: {
      selectedSubcategories: function () {
        const productCategoryId = this.modalData.product_category_id
        return this.subcategories.filter((sctg) => sctg.product_category_id === productCategoryId)
      }
    },
    beforeCreate () {
      this.loaded = false
      api.post('products/list').then(response => {
        this.loaded = true
        this.list = response.data.products
        this.categories = response.data.categories
        this.subcategories = response.data.subcategories
      })
    },
    methods: {
      addPrice () {
        if (!this.price_new.price_name) {
          this.modalError = 'Не указано название прайса'
          return
        }
        var data = Object.assign({}, this.price_new, {product_id: this.modalData.id})
        data = this.prepPost(data)
        this.price_new = {}
        api.post('products/addprice', data).then(response => {
          if (response.data.prices) {
            this.modalData.prices = response.data.prices
          } else {
            this.modalError = response.data
          }
        }).catch(res => {
          this.modalError = 'Ошибка'
        })
      },
      delPrice (id, name) {
        if (!confirm('Удалить прайс "' + name + '"')) {
          return
        }
        api.post('products/delprice', this.prepPost({id: id})).then(response => {
          this.modalData.prices = response.data.prices
        })
      },
      formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ` `)
      },
      beforeClose () {
      },
      refreshList () {
        this.loaded = false
        var data = this.prepPost({ product_category_id: this.filterCategory })
        api.post('products/list', data).then(response => {
          this.loaded = true
          this.list = response.data.products
          this.categories = response.data.categories
        })
      },
      onFilter () {
        this.refreshList()
      },
      add () {
        this.modalShow = true
      },
      edit (item) {
        var copyItem = {}
        Object.assign(copyItem, item)
        this.modalShow = true
        this.modalData = copyItem
        var reqData = this.prepPost({product_id: copyItem.id})
        api.post('products/fetchphotos', reqData).then(res => {
          if (res.data.photos) {
            this.photos = res.data.photos
          }
        })
      },
      close () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalClose () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalHide () {
        this.modalClose()
      },
      resetForm () {
        var form = document.querySelector('#modal-form')
        form.reset()
      },
      prepPost (data) {
        var formData = new FormData()
        for (let key in data) {
          if (Array.isArray(data[key])) {
            for (let i in data[key]) {
              formData.append(key + '[]', data[key][i])
            }
          } else {
            let val = data[key] || ''
            formData.append(key, val)
          }
        }
        return formData
      },
      store () {
        var formData = this.prepPost(this.modalData)
        var input = document.querySelector('#image')
        if (input && input.files.length) {
          var file = document.querySelector('#image').files[0]
          formData.append('image', file)
        }

        api.post('products/store', formData).then(response => {
          if (response.data.success) {
            this.modalClose()
            this.refreshList()
          } else {
            this.modalError = response.data.message
          }
        })
      },
      del (id, name) {
        if (!confirm('Удалить товар "' + name + '"')) {
          return
        }

        var formData = new FormData()
        formData.append('id', id)

        api.post('products/delete', formData)
          .then(res => { this.refreshList() })
      },
      resetModal () {
        this.modalData = {
          subcategories_ids: [],
          photos: [],
          product_category_id: null
        }
      },
      uploadImage (item) {
        var formData = new FormData()
        formData.append('id', item.id)

        var file = document.querySelector('#image').files[0]
        formData.append('image', file)

        api.post('products/upload', formData)
      },
      exportEmails (filename) {
        var self = this
        api.post('orders/emaillist').then(response => {
          this.loaded = true
          self.exportToCsv(filename, response.data)
        })
      },
      exportToCsv (filename, rows) {
        var processRow = function (row) {
          var finalVal = ''
          for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString()
            if (row[j] instanceof Date) {
              innerValue = row[j].toLocaleString()
            }

            var result = innerValue.replace(/"/g, '""')
            if (result.search(/("|,|\n)/g) >= 0) {
              result = '"' + result + '"'
            }

            // if (j > 0) {
            //   finalVal += ','
            // }

            finalVal += result
          }
          return finalVal + '\n'
        }

        var csvFile = ''
        for (var i = 0; i < rows.length; i++) {
          csvFile += processRow(rows[i])
        }

        var blob = new Blob([csvFile], {type: 'text/csv;charset=utf-8;'})
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, filename)
        } else {
          var link = document.createElement('a')
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', filename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      },
      addPhoto () {
        var formData = new FormData()
        formData.append('photo', document.querySelector('#photo-file').files[0])
        formData.append('product_id', this.modalData.id)
        var $self = this
        api.post('products/addphoto', formData).then(function (res) {
          if (res.data.photos && res.data.photos.length) {
            $self.photos = res.data.photos
            document.querySelector('#photo-file').value = ''
          }
        })
      },
      delPhoto (id) {
        if (!confirm('Удалить изображение #' + id)) {
          return
        }
        api.post('products/delphoto', this.prepPost({id: id})).then(response => {
          this.photos = response.data.photos
        })
      },
      setHoverImage (id) {
        api.post('products/sethoverphoto', this.prepPost({id: id})).then(response => {
          this.photos = response.data.photos
        })
      }
    }
  }
</script>

<style>
  .image-wrap {
/*    width: 370px;
    height: 248px;*/
    width: 100%;
    height: 67%;
    width: 568px;
    height: 380px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .whenHover {
    background-color: #a7e8a7;
  }

  /**/
  .hidden-element {
    background-color: #c0c0c05c;
    color: silver;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminProducts.vue